function resolveRelayUrl() {
  const envBase = (process.env.REACT_APP_SERVER || '').replace(/\/$/, '');
  if (envBase) {
    return `${envBase}/v1/chat/completions`;
  }
  return '/v1/chat/completions';
}

function appendSseLines(buffer, text, onDataLine) {
  buffer += text;
  const lines = buffer.split('\n');
  const keep = lines.pop() ?? '';
  for (const line of lines) {
    const trimmed = line.replace(/\r$/, '');
    if (trimmed.startsWith('data:')) {
      onDataLine(trimmed.slice(5).trim());
    }
  }
  return keep;
}

export async function streamChatCompletions({
  authorization,
  messages,
  model,
  temperature,
  top_p,
  frequency_penalty,
  presence_penalty,
  signal,
  onDelta
}) {
  const url = resolveRelayUrl();
  const res = await fetch(url, {
    method: 'POST',
    signal,
    headers: {
      'Content-Type': 'application/json',
      Authorization: authorization
    },
    body: JSON.stringify({
      model,
      messages,
      stream: true,
      temperature,
      top_p,
      frequency_penalty,
      presence_penalty
    })
  });

  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const errJson = await res.json();
      if (errJson?.error?.message) {
        msg = errJson.error.message;
      }
    } catch {
      try {
        msg = await res.text();
      } catch {
        // ignore
      }
    }
    throw new Error(msg);
  }

  if (!res.body?.getReader) {
    throw new Error('当前环境不支持流式读取');
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let sseBuffer = '';
  let fullText = '';

  const handlePayload = (payload) => {
    if (payload === '[DONE]') {
      return;
    }
    try {
      const json = JSON.parse(payload);
      const delta = json?.choices?.[0]?.delta?.content;
      if (typeof delta === 'string' && delta.length) {
        fullText += delta;
        if (typeof onDelta === 'function') {
          onDelta(delta);
        }
      }
    } catch {
      // ignore
    }
  };

  while (true) {
    const { done, value } = await reader.read();
    if (value) {
      sseBuffer = appendSseLines(sseBuffer, decoder.decode(value, { stream: true }), handlePayload);
    }
    if (done) {
      sseBuffer = appendSseLines(sseBuffer, decoder.decode(), handlePayload);
      if (sseBuffer.trim()) {
        const trimmed = sseBuffer.replace(/\r$/, '');
        if (trimmed.startsWith('data:')) {
          handlePayload(trimmed.slice(5).trim());
        }
      }
      break;
    }
  }

  return fullText;
}
